import gql from 'graphql-tag';

export const TIMEZONES = gql`
  query timezones {
    timezones {
      key
      value
    }
  }
`;
